import React from "react";
import "./Testimonials.css";

export default function Testimonials() {
  return (
    <div className="testimonial">
      <div className="clients">Clients</div>
      <br></br>
      <span className="testimonials">Testimonials</span>
      <br></br>
      <span className="description">
        "It was a fantastic evening in your superb restaurant which was enjoyed
        by everyone who was fortunate to be there"
      </span>
      <br></br>
      <div className="customer">John Doe</div>
    </div>
  );
}
